var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgPremium = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.793 2.803L5.796 5.39 4.298 4.012 2.833 2.635v15.857h5.79V13.43h6.471v5.06h5.789V2.917l-1.498 1.209-1.465 1.18-2.826-2.53C13.527 1.37 12.13.217 11.994.217c-.136 0-1.566 1.153-3.2 2.586zM2.833 22.568v1.266h18.05V21.303H2.833v1.265z"
})));
export default SvgPremium;